import {clientRestAPI} from "../clientRestAPI/clientRestAPI";
import {toast} from "react-toastify";

const url = "/log-movimentacao";

const logMovimentacaoModel = {
  state: {
    listaLogMovimentacao: [],
    loading: false,
    errors: {},
    redirect: false
  },

  //definindo todos os reducers
  reducers: {
    fetchLogMovimentacaoPending: (state) => {
      return {
        ...state,
        loading: true,
        redirect: false
      };
    },

    fetchListaLogMovimentacaoFulfiled: (state, payload) => {
      return {
        ...state,
        listaLogMovimentacao: payload.data || payload,
        loading: false,
        redirect: false
      };
    },

    fetchListaLogMovimentacaoRejected: (state, payload) => {
      const errors = {global: payload.message};
      toast.error("Erro ao buscar lista movimentação escrituração! " + errors.global);
      return {
        ...state,
        errors: errors,
        loading: false
      };
    }
  },

  //definindo os effects
  effects: dispatch => ({
    fetchListaLogMovimentacao(id) {

      dispatch.logMovimentacaoModel.fetchLogMovimentacaoPending();

      return clientRestAPI
        .get(`${url}/all/${id}`)
        .then(res => {
          //caso tudo ocorra bem, o reducer abaixo vai ser acionado
          dispatch.logMovimentacaoModel.fetchListaLogMovimentacaoFulfiled(res.data);
        })
        .catch(err => {
          //caso ocorra algum problema, o reducer abaixo vai ser acionado
          dispatch.logMovimentacaoModel.fetchListaLogMovimentacaoRejected(err);
        });
    },
  })
};

export default logMovimentacaoModel;
